import type { SessionListItem } from '../../contracts';

export const resolvePatientName = (session: SessionListItem): string | undefined => {
  const profileName = session.patient_profile_name;
  return profileName?.trim() || session.patient.name?.trim();
};
